import React, { useState } from "react";
import { Tag } from "@/components/shared/Tag";
import { Button } from "@/components/ui/Button";
import { Badge } from "@/components/ui/Badge";
import { X } from "lucide-react";

const CollapsibleTagList = ({ values = [], onRemove, maxVisible = 5, isTag = false }) => {
  const [expanded, setExpanded] = useState(false);

  const visible = expanded ? values : values.slice(0, maxVisible);
  const hiddenCount = values.length - maxVisible;

  return (
    <div className="flex flex-wrap gap-2">
      {visible.map((tag, i) => {
        if (isTag) {
          return <Tag key={i} text={tag} onRemove={onRemove ? () => onRemove(i) : undefined} />;
        }

        return (
          <Badge
            key={i}
            label={
              <div className="flex items-center gap-2 max-w-[200px]">
                <span className="truncate block max-w-[160px]" title={tag}>
                  {tag}
                </span>

                {/* A real button, named for what it removes: a span with an
                    onClick could be neither reached by keyboard nor read by a
                    screen reader. type="button", or it submits the form. */}
                {onRemove && (
                  <button
                    type="button"
                    aria-label={`Remove ${tag}`}
                    onClick={() => onRemove(i)}
                    className="flex-shrink-0 cursor-pointer text-text-primary !text-sm rounded-lg"
                  >
                    <X size={14} strokeWidth={2} />
                  </button>
                )}
              </div>
            }
            variant="gradient"
            colorIndex={i % 6}
            className="rounded-md inline-flex h-7 items-center border-[1px] max-w-[220px]"
            badgeStyle="py-0.5"
          />
        );
      })}

      {!expanded && hiddenCount > 0 && (
        <Button
          type="button"
          onClick={() => setExpanded(true)}
          className="px-3 py-1 text-xs border border-dashed border-background-tertiary bg-background-primary rounded-md text-text-secondary hover:text-text-primary hover:bg-background-tertiary/20 transition"
        >
          +{hiddenCount} more
        </Button>
      )}

      {expanded && values.length > maxVisible && (
        <Button
          type="button"
          onClick={() => setExpanded(false)}
          className="px-3 py-1 text-xs border border-dashed border-background-tertiary bg-background-primary rounded-md text-text-secondary hover:text-text-primary hover:bg-background-tertiary/20 transition"
        >
          Show less
        </Button>
      )}
    </div>
  );
};

export default CollapsibleTagList;
